package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AppStaffUpdateRequest(
    @SerialName("name") val name: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("push_notification_enabled") val pushNotificationEnabled: Boolean? = null,
    @SerialName("email_notification_enabled") val emailNotificationEnabled: Boolean? = null,
    @SerialName("profile_image_file_id") val profileImageFileId: String? = null
)
